import React from "react";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import MenuItem from "@mui/material/MenuItem";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function EditFreightForwarder() {
  const history = useHistory();
  let { id } = useParams();
  const data_params = { id: id };
  const classes = useStyles();
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [tel, setTel] = useState("");
  const [mac5code, setMAC5Code] = useState("");
  const [contact, setContact] = useState("");
  const [ForwarderStatus, setForwarderStatus] = useState(1);
  const [FreightForwarderName, setFreightForwarderName] = useState("");
  const [FreightForwarderNo, setFreightForwarderNo] = useState("");
  const [ModId, setModId] = useState("1");
  const [Submitting, setSubmitting] = useState(false);
  const EmpId = localStorage.getItem("EmpId");

  const getData = async () => {
    try {
      const data = await api
        .post("api/forwarder/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            console.log(response.data);
            [].concat(response.data).map((res) => {
              setFreightForwarderName(res.FreightForwarderName);
              setFreightForwarderNo(res.FreightForwarderNo);
              setModId(res.ModID);
              setMAC5Code(res.FreightForwarderMAC5Code)
              setAddress(res.FreightForwarderAddress)
              setContact(res.LinersContactName)
              setEmail(res.FreightForwarderEmail)
              setTel(res.FreightForwarderTel)
              // res.Status.data.map((res) => {
              //   setForwarderStatus(res);
              // });
              setForwarderStatus(res.Status === true ? 1 : 0);
            });
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/FreightForwarder");
                }
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const addData = async () => {
    if (FreightForwarderName !== "" && FreightForwarderNo !== "") {
      const data = {
        no: FreightForwarderNo,
        name: FreightForwarderName,
        status: ForwarderStatus,
        createId: EmpId,
        FreightForwarderMAC5Code: mac5code,
        FreightForwarderAddress: address,
        FreightForwarderContactName: contact,
        FreightForwarderEmail: email,
        FreightForwarderTel: tel
      };

      api
        .post("api/forwarder/create", data)
        .then((respose) => {
          const MySwal = withReactContent(Swal);

          MySwal.fire({
            icon: "success",
            didOpen: () => {
              MySwal.clickConfirm();
            },
          }).then(() => {
            return MySwal.fire(
              "สำเร็จ!",
              "เพิ่มตัวแทนการขนส่ง !",
              "success"
            ).then((result) => {
              if (result.isConfirmed) {
                history.push("/Setting/FreightForwarder");
              }
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });

      // alert(JSON.stringify(data, null, 2));
      setSubmitting(false);
    } else {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน");
    }
  };

  const editData = async () => {
    const data = {
      id: id,
      no: FreightForwarderNo,
      name: FreightForwarderName,
      status: ForwarderStatus,
      ModId: EmpId,
      FreightForwarderMAC5Code: mac5code,
      FreightForwarderAddress: address,
      FreightForwarderContactName: contact,
      FreightForwarderEmail: email,
      FreightForwarderTel: tel
    };

    api
      .post("api/forwarder/update", data)
      .then((respose) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
          icon: "success",
          didOpen: () => {
            MySwal.clickConfirm();
          },
        }).then(() => {
          return MySwal.fire(
            "สำเร็จ!",
            "แก้ไขตัวแทนการขนส่ง !",
            "success"
          ).then((result) => {
            if (result.isConfirmed) {
              history.push("/Setting/FreightForwarder");
            }
          });
        });
      })
      .catch((err) => {
        console.log(err);
      });
    // alert(JSON.stringify(data, null, 2));
    setSubmitting(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (id) {
      editData();
    } else {
      addData();
    }
  };

  useEffect(() => {
    if (id) {
      getData();
    }
  }, []);

  return (
    <div>
      <Card
        variant="outlined"
        style={{ padding: "20px", margin: "25px", height: "86vh" }}
      >
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ตัวแทนการขนส่ง
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Freight Forwarder
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Freight Forwarder
            </Typography>
          </Grid>
        </Grid>

        <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
          <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
            ตัวแทนการขนส่ง
          </h6>
          <Grid container spacing={2} sx={{marginBottom:"20px"}}>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                name="NameFreightForwarder"
                label="Name Freight Forwarder"
                variant="outlined"
                placeholder="Enter Name Freight Forwarder"
                style={{
                  width: "100%",
                }}
                onChange={(e) => setFreightForwarderName(e.target.value)}
                // onBlur={handleBlur}
                classes={{ root: !FreightForwarderName ? classes.customOutline : null }}
                required
                InputLabelProps={{ shrink: true }}
                value={FreightForwarderName}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}></Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Freight Forwarder NO."
                InputLabelProps={{ shrink: true }}
                placeholder="Enter Freight Forwarder  NO."
                name="FreightForwarderNO"
                style={{
                  width: "100%",

                }}
                onChange={(e) => setFreightForwarderNo(e.target.value)}
                // onBlur={handleBlur}
                classes={{ root: !FreightForwarderNo ? classes.customOutline : null }}
                required
                value={FreightForwarderNo}
              />
              {/* {errors.polpod_no && touched.polpod_no && errors.polpod_no} */}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>

              <TextField
                name="MAC5"
                label="MAC-5 Code "
                variant="outlined"
                placeholder="Enter MAC-5 Code "
                style={{
                  width: "100%",

                }}
                onChange={(e) => {
                  setMAC5Code(e.target.value);
                }}
                InputLabelProps={{ shrink: true }}
                value={mac5code}

              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}></Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                name="Address"
                label="Address"
                variant="outlined"
                placeholder="Enter Address"
                style={{
                  width: "100%",

                }}
                onChange={(e) => {
                  setAddress(e.target.value)
                }}
                InputLabelProps={{ shrink: true }}
                value={address}

              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}></Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="Contact"
                label="Contact Name"
                variant="outlined"
                placeholder="Enter Contact Name"
                style={{
                  width: "100%",

                }}
                onChange={(e) => {
                  setContact(e.target.value);
                }}
                InputLabelProps={{ shrink: true }}
                value={contact}

              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="Email"
                label="Email"
                variant="outlined"
                placeholder="Enter Email"
                style={{
                  width: "100%",

                }}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                InputLabelProps={{ shrink: true }}
                value={email}

              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}></Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="Telephone"
                label="Telephone"
                variant="outlined"
                placeholder="Enter Telephone"
                style={{
                  width: "100%",

                }}
                onChange={(e) => {
                  setTel(e.target.value);
                }}
                InputLabelProps={{ shrink: true }}
                value={tel}

              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>

              <FormControl fullWidth>
                <InputLabel id="select_status-label">Status</InputLabel>
                <Select
                  name="select_status"
                  id="select_status"
                  value={ForwarderStatus}
                  label="Status"
                  style={{
                    width: "100%",

                  }}
                  onChange={(e) => setForwarderStatus(e.target.value)}
                >
                  <MenuItem value={1}>Active</MenuItem>
                  <MenuItem value={0}>InActive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Button
            type="button"
            variant="outlined"
            style={{
              color: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
            onClick={history.goBack}
          >
            back
          </Button>
          <Button
            type="submit"
            variant="contained"
            style={{
              background: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
            disabled={Submitting}
          >
            {Submitting && <CircularProgress size={22} />}
            {!Submitting && "SAVE"}
          </Button>
        </form>
      </Card>
    </div >
  );
}
